import styled from 'styled-components';
import { Box } from '@chakra-ui/react';

export interface IStyled {
  color?: string;
  size?: string;
  $Cpos?: string;
  $noSphere?: boolean;
}

export const Container = styled(Box)<IStyled>`
  --size: ${props => props.size || '16px'};
  position: relative;
  width: fit-content;
  height: fit-content;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  :after {
    --size: 90%;
    content: '';
    display: ${props => (props.$noSphere ? 'none' : 'block')};
    position: absolute;
    width: var(--size);
    height: var(--size);
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.secondary};
    z-index: -1;
    transform: translate(-50%, -50%);
    ${props => props.$Cpos}
  }
  svg {
    z-index: 5;
    width: var(--size);
    height: var(--size);
  }
`;
